
const BaseFallback = require("@/modules/core/components/BaseFallback").default;

let Routes         = []; 
let RoutesSettings = [];
let RoutesData     = [];
let name           = null;
let module         = null;
let moduleName     = null;
let i              = 0;
let types          = ['Routes','BaseDataRoutes','SettingsRoutes'];

const requireContext = require.context('./modules', true, /.*Routes\.js$/);

const modulesRoutes = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)]
  )
  .reduce((modules, [name, module]) => {

    let parts = [];
    if (module.namespaced === undefined) {
      module.namespaced = true
    }

    parts = name.split('/');
    name  = parts[parts.length - 1];
  
    return { ...modules, [name]: module }
 
  }, {});

for (name in modulesRoutes) {
    module = modulesRoutes[name];
    moduleName = name.substr(0, name.length - 6);
    for (i = 0; i < types.length; i++) {
        switch(types[i]) {
            case 'BaseDataRoutes':
                if (module[moduleName + types[i]] !== undefined) {
                    RoutesData.push(...module[moduleName + types[i]]);
                } 
                break;
            case 'SettingsRoutes':
                if (module[moduleName + types[i]] !== undefined) {
                    RoutesSettings.push(...module[moduleName + types[i]]);
                } 
                break;
            default:
                if (module[moduleName + types[i]] !== undefined) {
                    Routes.push(...module[moduleName + types[i]]);
                } 
                break;
        }
    }
}

// Add the settings or base routes
Routes = Routes.map(Route => {
    if (Route.name === 'settings') {
        Route.children = RoutesSettings;
    }
    if (Route.name === 'basedata') {
        Route.children = RoutesData;
    }
    return Route;
});

let foundFallback = false;

for (let i = 0; i < Routes.length; i++) {
    if (Routes[i].path === '*') {
        foundFallback = true;
    }
}

if (foundFallback === false) {
    Routes.push({
        name: "Fallback",
        path: "*",
        component:  BaseFallback
    });
}

export default Routes; 